export default {
  // Buttons
  addConfig: 'Add Config',
  searchButton: 'Search',
  edit: 'Edit',
  delete: 'Delete',

  // Table columns
  configKey: 'Config Key',
  configValue: 'Config Value',
  description: 'Description',
  status: 'Status',
  createTime: 'Creation Time',
  updateTime: 'Update Time',
  operation: 'Operation',

  // Status values
  enabled: 'Enabled',
  disabled: 'Disabled',

  // Modal
  addConfigTitle: 'Add Config',
  editConfigTitle: 'Edit Config',

  // Form fields
  configKeyField: 'Config Key',
  configKeyPlaceholder: 'Please enter config key',
  configValueField: 'Config Value',
  configValuePlaceholder: 'Please enter config value',
  descriptionField: 'Description',
  descriptionPlaceholder: 'Please enter description',
  statusField: 'Status',

  // Switch labels
  enabledText: 'Enabled',
  disabledText: 'Disabled',

  // Validation
  configKeyRequired: 'Please enter config key',
  configValueRequired: 'Please enter config value',
  descriptionRequired: 'Please enter description',

  // Buttons
  cancel: 'Cancel',
  confirm: 'Confirm',

  // Messages
  addSuccess: 'Config added successfully',
  editSuccess: 'Config updated successfully',
  deleteSuccess: 'Config deleted successfully',

  // Delete confirmation
  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Are you sure you want to delete "{key}"?',
  deleteConfirm: 'Delete',
}
